/**
 * Meta Pixel (Facebook Pixel) Tracking Utilities
 *
 * Base pixel code is loaded in public/index.html
 * This file provides helper functions to track custom events
 */

/**
 * Track CompleteRegistration event
 * Call this when a user successfully completes registration/signup
 */
export const trackCompleteRegistration = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', 'CompleteRegistration');
      console.log('[Meta Pixel] CompleteRegistration event tracked');
    } catch (error) {
      console.error('[Meta Pixel] Failed to track CompleteRegistration:', error);
    }
  }
};

/**
 * Track Login event
 * Call this when a user successfully logs in
 */
export const trackLogin = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', 'Login');
      console.log('[Meta Pixel] Login event tracked');
    } catch (error) {
      console.error('[Meta Pixel] Failed to track Login:', error);
    }
  }
};

/**
 * Track FirstChat event (Custom Event)
 * Call this when a user sends their first chat message
 */
export const trackFirstChat = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', 'FirstChat');
      console.log('[Meta Pixel] FirstChat event tracked');
    } catch (error) {
      console.error('[Meta Pixel] Failed to track FirstChat:', error);
    }
  }
};

/**
 * Track custom event with parameters
 * @param {string} eventName - Name of the custom event
 * @param {object} params - Additional parameters for the event
 */
export const trackCustomEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', eventName, params);
      console.log(`[Meta Pixel] ${eventName} event tracked with params:`, params);
    } catch (error) {
      console.error(`[Meta Pixel] Failed to track ${eventName}:`, error);
    }
  }
};

// Export default object with all functions
export default {
  trackCompleteRegistration,
  trackLogin,
  trackFirstChat,
  trackCustomEvent,
};
